/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2023-03-01 15:00:00
 *
 *******************************************************/

import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import { Card, Button, Link, Banner } from '@shopify/polaris';
import * as installActions from 'actions/install-actions';
import { getMinuteToCompleteText } from 'src/helpers/installation-helper';
import { SkeletonDisplayText, SkeletonBodyText } from '@shopify/polaris';
import { ONBOARDING_V3_THEME_SETUP_DATA_KEY } from './screen.choose-theme';
import history from 'src/routes/history';
import { routes } from 'src/routes';
import { getThemeReviewUrl } from 'src/helpers';

type Props = WithI18nProps;

const TypeScreenSync = {
  RUNNING_THEME_SETUP_AND_SYNC: 1,
  RUNNING_SYNC_AND_DONE_THEME_SETUP: 2,
  RUNNING_THEME_SETUP_FAIL: 3,
  DONE_THEME_SETUP_AND_SYNC: 4
};

const SyncInfo = ({ progressSync, timeToCompleteText, syncStatusInfoStartAt, i18n }) => (
  <div className="sync-info">
    <div className="card">
      <div className="title">
        <span className="refresh">
          <img
            className={`refresh ${+progressSync === 100 ? '' : 'loading'}`}
            src="/assets/images/installation/icon-refresh.svg"
            alt="icon"
          />
        </span>
        <span>{i18n.translate('AdminHTML.ThemeSetup.Onboarding.theme_setup_sync_status')}</span>
      </div>
      <div className="progress">
        <div className="progressing" style={{ '--size': `${progressSync}%` }}></div>
      </div>
      <div className="est">
        <span className="est-wrap">
          <span className="est-text">
            {i18n.translate('AdminHTML.ThemeSetup.Onboarding.theme_setup_est')}{' '}
          </span>
          <span style={{ fontWeight: '500' }}>
            {+timeToCompleteText === 0 && +progressSync === 100
              ? 'Done'
              : `${timeToCompleteText || '1'} ${i18n.translate(
                  'AdminHTML.ThemeSetup.Onboarding.theme_setup_minutes'
                )}`}
          </span>
        </span>
        <span className="percent" style={{ fontWeight: '500' }}>
          {progressSync}%
        </span>
      </div>
      {/* <span className="est-wrap">
        <span className="est-text">
          {i18n.translate('AdminHTML.ThemeSetup.Onboarding.theme_setup_sync_started')}{' '}
        </span>
        <span style={{ fontWeight: '500' }}>{formatDatetime(syncStatusInfoStartAt)}</span>
      </span> */}
    </div>
  </div>
);

class RunningSyncScreen extends Component<Props> {
  state = {
    currentScreen: null,
    progressSync: 0,
    timeToCompleteText: '',
    syncStatusInfoStartAt: Math.round(new Date().getTime() / 1000),
    themeSetupInfoShopifyThemeName: this.props.themeSetupInfoShopifyThemeName,
    themeSetupInfoIsLiveTheme: this.props.themeSetupInfoIsLiveTheme,
    themeSetupInfoTaeFeatures: this.props.themeSetupInfoTaeFeatures,
    themeSetupInfoThemeId: this.props.themeSetupInfoThemeId,
    themeSetupInfoThemeName: this.props.themeSetupInfoThemeName,
    themeSetupInfoBoostThemeLib: this.props.themeSetupInfoBoostThemeLib,
    themeSetupInfoBoostThemeLibVersion: this.props.themeSetupInfoBoostThemeLibVersion
  };

  componentDidMount() {
    const { getInstallStatus, tenantApp } = this.props;
    getInstallStatus();

    try {
      const themeSetupData = localStorage.getItem(
        `${tenantApp?.tenantId}-${ONBOARDING_V3_THEME_SETUP_DATA_KEY}`
      );
      if (themeSetupData && themeSetupData !== 'undefined') {
        this.setState({ themeSetupData: JSON.parse(themeSetupData) });
      }
    } catch (error) {}
  }

  componentWillReceiveProps(nextProps) {
    const {
      getInstallStatus,
      syncInfoStartAt,
      syncInfoStatus,
      syncInfoProgress,
      syncInfoLastSyncedDoneAt,
      themeSetupInfoStatus
    } = nextProps;

    this.setState({
      themeSetupInfoShopifyThemeName: nextProps.themeSetupInfoShopifyThemeName,
      themeSetupInfoIsLiveTheme: nextProps.themeSetupInfoIsLiveTheme,
      themeSetupInfoTaeFeatures: nextProps.themeSetupInfoTaeFeatures,
      themeSetupInfoThemeId: nextProps.themeSetupInfoThemeId,
      themeSetupInfoThemeName: nextProps.themeSetupInfoThemeName,
      themeSetupInfoBoostThemeLib: nextProps.themeSetupInfoBoostThemeLib,
      themeSetupInfoBoostThemeLibVersion: nextProps.themeSetupInfoBoostThemeLibVersion
    });

    if (
      (syncInfoStatus === 'done' && themeSetupInfoStatus === 'done') ||
      (syncInfoStatus === 'done' && themeSetupInfoStatus === 'error') ||
      (syncInfoStatus === 'error' && themeSetupInfoStatus === 'done') ||
      (syncInfoStatus === 'error' && themeSetupInfoStatus === 'error')
    ) {
    } else if (syncInfoStatus !== 'done' && syncInfoProgress !== 1 && nextProps.loading === false) {
      setTimeout(() => {
        getInstallStatus();
      }, 5000);
    } else if (themeSetupInfoStatus === 'running' && nextProps.loading === false) {
      setTimeout(() => {
        getInstallStatus();
      }, 5000);
    }

    const timeToCompleteText = getMinuteToCompleteText(
      syncInfoStartAt,
      syncInfoLastSyncedDoneAt,
      syncInfoProgress
    );

    this.setState({
      progressSync: Number(syncInfoProgress * 100)
        .toFixed(1)
        .replace('.0', ''),
      timeToCompleteText,
      syncStatusInfoStartAt: syncInfoStartAt
    });

    const currentScreen = getScreen(themeSetupInfoStatus, syncInfoStatus);
    this.setState({ currentScreen });
  }

  getThemeSetupSuccessInfoDescription = (themeData, i18n) => {
    // We have successfully set up the xxx features for the theme yyy
    const {
      themeSetupInfoShopifyThemeName,
      themeSetupInfoIsLiveTheme,
      themeSetupInfoTaeFeatures,
      themeSetupInfoThemeName
    } = themeData;

    const featuresArr = _.keys(themeSetupInfoTaeFeatures)
      .map(feature => {
        if (themeSetupInfoTaeFeatures[feature] === 'installed') {
          return feature;
        }
        return false;
      })
      .filter(i => i);

    const featuresArrTextLabel = featuresArr
      .map(feature => {
        const f = {
          recommendation: i18n
            .translate('AdminHTML.ThemeSetup.NewThemeSetup.step1_Feature_Recommendations')
            .toLowerCase(),
          instantSearch: i18n
            .translate('AdminHTML.ThemeSetup.NewThemeSetup.step1_Feature_Instant')
            .toLowerCase(),
          filterCollection: i18n
            .translate('AdminHTML.ThemeSetup.NewThemeSetup.step1_Feature_Collection')
            .toLowerCase(),
          filterSearch: i18n
            .translate('AdminHTML.ThemeSetup.NewThemeSetup.step1_Feature_Search')
            .toLowerCase()
        };
        return f[feature];
      })
      .join(', ');

    const themeInfoText = ` ${themeSetupInfoIsLiveTheme ? 'LIVE ' : ''}${
      themeSetupInfoThemeName || themeSetupInfoShopifyThemeName
    }`;

    return i18n.translate('AdminHTML.ThemeSetup.Onboarding.theme_setup_ready_description1', {
      x: <b>{featuresArrTextLabel}</b>,
      y: <b>{themeInfoText}</b>
    });
  };

  gotoDashboard = () => {
    const { updateInstallationStatus } = this.props;
    updateInstallationStatus('');
    history.push(routes.dashboard.view());
  };

  gotoFrontStore = themeId => {
    const frontStoreLink = getThemeReviewUrl(themeId);
    window.open(frontStoreLink, '_blank');
  };

  contactUs = () => {
    const { updateInstallationStatus } = this.props;
    updateInstallationStatus('submitted-opensurvey');
    history.push(routes.newInstallation.survey());
  };

  render() {
    const {
      currentScreen,
      progressSync,
      timeToCompleteText,
      syncStatusInfoStartAt,
      themeSetupInfoShopifyThemeName,
      themeSetupInfoIsLiveTheme,
      themeSetupInfoTaeFeatures,
      themeSetupInfoThemeId,
      themeSetupInfoThemeName,
      themeSetupInfoBoostThemeLib,
      themeSetupInfoBoostThemeLibVersion
    } = this.state;

    const { i18n } = this.props;

    return (
      <div className="BC-AnotherLayout BC-page_Installation RunningSync">
        <Card>
          <div className="BC-page_Installation--RunningSync">
            <div className="wrapper">
              {currentScreen === TypeScreenSync.RUNNING_THEME_SETUP_AND_SYNC && (
                <div className="left">
                  <div className="left-img">
                    <img src="/assets/images/installation/running-sync.gif" alt="running" />
                  </div>
                </div>
              )}
              {currentScreen === TypeScreenSync.RUNNING_SYNC_AND_DONE_THEME_SETUP && (
                <div className="left">
                  <div className="left-img">
                    <img
                      src="/assets/images/installation/running-theme-setup-success.gif"
                      alt="running"
                    />
                  </div>
                </div>
              )}
              {currentScreen === TypeScreenSync.RUNNING_THEME_SETUP_FAIL && (
                <div className="left">
                  <div className="left-img">
                    <img
                      src="/assets/images/installation/running-theme-setup-fail.gif"
                      alt="running"
                    />
                  </div>
                </div>
              )}
              {currentScreen === TypeScreenSync.DONE_THEME_SETUP_AND_SYNC && (
                <div className="left">
                  <img
                    src="/assets/images/installation/running-2x.png"
                    width={520}
                    height={708}
                    alt="running"
                  />
                </div>
              )}

              <div className="right">
                {!currentScreen && (
                  <div className="right-content skeleton">
                    <div className="skeleton">
                      <div>
                        <SkeletonDisplayText size="medium" />
                      </div>
                      <div>
                        <SkeletonBodyText />
                      </div>
                      <div>
                        <SkeletonBodyText />
                      </div>
                    </div>
                  </div>
                )}
                {currentScreen === TypeScreenSync.RUNNING_THEME_SETUP_AND_SYNC && (
                  <div className="right-content">
                    <div className="title">
                      {i18n.translate('AdminHTML.ThemeSetup.Onboarding.theme_setup_get_ready')}
                      <div className="dots">
                        <div className="dots-3"></div>
                      </div>
                    </div>
                    <div className="description">
                      {i18n.translate(
                        'AdminHTML.ThemeSetup.Onboarding.theme_setup_get_ready_description'
                      )}
                    </div>
                    <SyncInfo
                      progressSync={progressSync}
                      timeToCompleteText={timeToCompleteText}
                      syncStatusInfoStartAt={syncStatusInfoStartAt}
                      i18n={i18n}
                    />
                  </div>
                )}
                {currentScreen === TypeScreenSync.RUNNING_SYNC_AND_DONE_THEME_SETUP && (
                  <div className="right-content">
                    <div className="title">
                      {i18n.translate('AdminHTML.ThemeSetup.Onboarding.theme_setup_get_ready2')}
                    </div>
                    <SyncInfo
                      progressSync={progressSync}
                      timeToCompleteText={timeToCompleteText}
                      syncStatusInfoStartAt={syncStatusInfoStartAt}
                      i18n={i18n}
                    />
                    <div className="description">
                      <br />
                      <Banner status="info">
                        <p>
                          {i18n.translate(
                            'AdminHTML.ThemeSetup.Onboarding.theme_setup_get_ready_description_t1',
                            {
                              t1: (
                                <b>
                                  {i18n.translate(
                                    'AdminHTML.ThemeSetup.Onboarding.theme_setup_get_ready_description_t1_1'
                                  )}
                                </b>
                              ),
                              t2: (
                                <b>
                                  {i18n.translate(
                                    'AdminHTML.ThemeSetup.Onboarding.theme_setup_get_ready_description_t1_2'
                                  )}
                                </b>
                              )
                            }
                          )}
                        </p>
                      </Banner>
                      <br />
                      <p>
                        {i18n.translate(
                          'AdminHTML.ThemeSetup.Onboarding.theme_setup_get_ready_description_t2',
                          {
                            t1: (
                              <b>
                                {i18n.translate(
                                  'AdminHTML.ThemeSetup.Onboarding.theme_setup_get_ready_description_t2_1'
                                )}
                              </b>
                            ),
                            t2: (
                              <b>
                                {i18n.translate(
                                  'AdminHTML.ThemeSetup.Onboarding.theme_setup_get_ready_description_t2_2'
                                )}
                              </b>
                            )
                          }
                        )}
                      </p>
                      <br />
                      <p>
                        {i18n.translate(
                          'AdminHTML.ThemeSetup.Onboarding.theme_setup_get_ready_description_t3',
                          {
                            contact: (
                              <span className="img-new-tab" onClick={this.contactUs}>
                                <Link>
                                  {i18n.translate(
                                    'AdminHTML.ThemeSetup.Onboarding.theme_setup_contact'
                                  )}
                                </Link>
                              </span>
                            )
                          }
                        )}
                      </p>
                    </div>

                    <div>
                      <div className="theme-setup-info">
                        <Button onClick={this.gotoDashboard}>
                          {i18n.translate(
                            'AdminHTML.ThemeSetup.Onboarding.theme_setup_go_dashboard'
                          )}
                        </Button>
                        <Button
                          onClick={() => this.gotoFrontStore(themeSetupInfoThemeId || '')}
                          primary>
                          {i18n.translate('AdminHTML.ThemeSetup.Onboarding.theme_setup_preview')}
                        </Button>
                      </div>
                    </div>
                  </div>
                )}
                {currentScreen === TypeScreenSync.RUNNING_THEME_SETUP_FAIL && (
                  <div className="right-content has-inner">
                    <div className="right-content-inner">
                      <div className="title">
                        {i18n.translate('AdminHTML.ThemeSetup.Onboarding.theme_setup_almost')}
                      </div>
                      <div className="description">
                        {i18n.translate(
                          'AdminHTML.ThemeSetup.Onboarding.theme_setup_almost_description'
                        )}
                      </div>
                      <Button primary onClick={this.gotoDashboard}>
                        {i18n.translate('AdminHTML.ThemeSetup.Onboarding.theme_setup_go_dashboard')}
                      </Button>
                    </div>
                  </div>
                )}
                {currentScreen === TypeScreenSync.DONE_THEME_SETUP_AND_SYNC && (
                  <div className="right-content has-inner">
                    <div className="right-content-inner">
                      <div className="title">
                        {i18n.translate('AdminHTML.ThemeSetup.Onboarding.theme_setup_ready')}
                      </div>
                      <div className="description" themeid={themeSetupInfoThemeId}>
                        {themeSetupInfoThemeId
                          ? this.getThemeSetupSuccessInfoDescription(
                              {
                                themeSetupInfoShopifyThemeName,
                                themeSetupInfoIsLiveTheme,
                                themeSetupInfoTaeFeatures,
                                themeSetupInfoThemeId,
                                themeSetupInfoThemeName,
                                themeSetupInfoBoostThemeLib,
                                themeSetupInfoBoostThemeLibVersion
                              },
                              i18n
                            )
                          : ''}
                      </div>
                      <div className="description" style={{ marginBottom: '25px' }}>
                        {i18n.translate(
                          'AdminHTML.ThemeSetup.Onboarding.theme_setup_ready_description2'
                        )}
                      </div>
                      <div className="action">
                        <Button onClick={this.gotoDashboard}>
                          {i18n.translate(
                            'AdminHTML.ThemeSetup.Onboarding.theme_setup_go_dashboard'
                          )}
                        </Button>
                        <Button
                          onClick={() => this.gotoFrontStore(themeSetupInfoThemeId || '')}
                          primary>
                          {i18n.translate('AdminHTML.ThemeSetup.Onboarding.theme_setup_preview')}
                        </Button>
                      </div>
                    </div>
                  </div>
                )}
                {currentScreen === TypeScreenSync.DONE_THEME_SETUP_AND_SYNC && (
                  <div className="contact-us">
                    <Link onClick={this.contactUs}>
                      {i18n.translate('AdminHTML.ThemeSetup.Onboarding.theme_setup_contact')}
                    </Link>
                  </div>
                )}
              </div>
            </div>
          </div>
        </Card>
      </div>
    );
  }
}

const getScreen = (themeSetupInfoStatus, syncInfoStatus) => {
  // theme: running, error, done
  // sync: running, error, done
  if (themeSetupInfoStatus === 'running' && syncInfoStatus === 'running') {
    return TypeScreenSync.RUNNING_THEME_SETUP_AND_SYNC;
  }

  if (themeSetupInfoStatus === 'running' && syncInfoStatus === 'done') {
    return TypeScreenSync.RUNNING_THEME_SETUP_AND_SYNC;
  }

  // Case unexpected
  if (themeSetupInfoStatus === 'running' && syncInfoStatus === 'error') {
    return TypeScreenSync.RUNNING_THEME_SETUP_AND_SYNC;
  }

  if (themeSetupInfoStatus === 'done' && syncInfoStatus === 'running') {
    return TypeScreenSync.RUNNING_SYNC_AND_DONE_THEME_SETUP;
  }

  if (themeSetupInfoStatus === 'done' && syncInfoStatus === 'done') {
    return TypeScreenSync.DONE_THEME_SETUP_AND_SYNC;
  }

  // Case unexpected
  if (themeSetupInfoStatus === 'done' && syncInfoStatus === 'error') {
    return TypeScreenSync.DONE_THEME_SETUP_AND_SYNC;
  }

  if (themeSetupInfoStatus === 'error') {
    return TypeScreenSync.RUNNING_THEME_SETUP_FAIL;
  }

  // Case unexpected
  if (themeSetupInfoStatus === 'done' && syncInfoStatus === '') {
    return TypeScreenSync.DONE_THEME_SETUP_AND_SYNC;
  }

  return TypeScreenSync.RUNNING_THEME_SETUP_AND_SYNC;
};

const mapStateToProps = (state, props) => {
  const { install } = state;
  return {
    tenantApp: _.get(state, 'oauth.tenantApp', null),
    loading: install.loading,
    installStatus: install.installStatus,
    installSyncPercent: install.installSyncPercent,
    installSetupThemePercent: install.installSetupThemePercent,
    installStep: install.installStep,
    installTotal: install.installTotal,
    installCurrentStep: install.installCurrentStep,
    installThemeId: install.installThemeId,
    installThemeName: install.installThemeName,
    installThemeUpdatedAt: install.installThemeUpdatedAt,

    syncInfoStartAt: _.get(install, 'syncStartedAt', Math.round(new Date().getTime() / 1000)),
    syncInfoStatus: _.get(install, 'syncStatus', ''),
    syncInfoProgress: _.get(install, 'syncProgress', 0),
    syncInfoLastSyncedStatus: _.get(install, 'syncInfoLastSyncedStatus', ''),
    syncInfoLastSyncedDoneAt: _.get(
      install,
      'syncInfoLastSyncedDoneAt',
      Math.round(new Date().getTime() / 1000)
    ),
    themeSetupInfoStatus: _.get(install, 'installStatus', 'running'),
    themeSetupInfoShopifyThemeName: _.get(install, 'installShopifyThemeName'),
    themeSetupInfoIsLiveTheme: _.get(install, 'themeSetupInfoIsLiveTheme'),
    themeSetupInfoTaeFeatures: _.get(install, 'installFeatures'),
    themeSetupInfoThemeId: _.get(install, 'installThemeId'),
    themeSetupInfoThemeName: _.get(install, 'installThemeName'),
    themeSetupInfoBoostThemeLib: _.get(install, 'themeSetupInfoBoostThemeLib'),
    themeSetupInfoBoostThemeLibVersion: _.get(install, 'installThemeLibVersion')
  };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  getInstallStatus: () => dispatch(installActions.getInstallStatus(ownProps.i18n)),
  updateInstallationStatus: status => dispatch(installActions.updateInstallationStatus(status))
});

export default connect(mapStateToProps, mapDispatchToProps)(withI18n()(RunningSyncScreen));
